// E-mailadressen altijd in kleine letters en zonder spaties, al tijdens het
// typen (telefoons zetten anders vaak een hoofdletter vooraan of een spatie
// achteraan). Zelfde regel als normalizeEmail in de backend.
export const toEmailInput = (value) => String(value || '').replace(/\s+/g, '').toLowerCase();

// Extra attributen voor e-mailvelden: geen automatische hoofdletter/verbetering.
export const emailInputProps = {
  autoCapitalize: 'none',
  autoCorrect: 'off',
  spellCheck: false,
  inputMode: 'email',
};
